import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [otp, setOTP] = useState('');
    const { login } = useContext(AuthContext);

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await login(username, password, otp);
            navigate(from, { replace: true });
        } catch (error) {
            alert('Login failed: ' + error.message);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="auth-wrapper">
                <div className="auth-content text-center">
                    <div className="card borderless">
                        <div className="row align-items-center ">
                            <div className="col-md-12">
                                <div className="card-body">
                                    <h4 className="mb-3 f-w-400">Signin</h4>
                                    <hr />
                                    <div className="form-group mb-3">
                                        <input type="text" className="form-control" placeholder="Username" autoFocus required
                                            value={username}
                                            onChange={(e) => setUsername(e.target.value)} />
                                    </div>
                                    <div className="form-group mb-4">
                                        <input type="password" className="form-control" placeholder="Password" required
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)} />
                                    </div>
                                    <div className="form-group mb-4">
                                        <input type="number" className="form-control" placeholder="OTP" required
                                            value={otp}
                                            onChange={(e) => setOTP(e.target.value)} />
                                    </div>
                                    <div className="custom-control custom-checkbox text-left mb-4 mt-2">
                                        <input type="checkbox" className="custom-control-input" id="customCheck1" />
                                        <label className="custom-control-label" htmlFor="customCheck1">Save credentials.</label>
                                    </div>
                                    <button type='submit' className="btn btn-block btn-primary mb-4">Signin</button>
                                    <hr />
                                    <img src="images/fullLogoBlack.png" alt="" className="mb-0" height={100} />
                                    {/* <p className="mb-2 text-muted">Forgot password? <a href="auth-reset-password.html" className="f-w-400">Reset</a></p> */}
                                    {/* <p className="mb-0 text-muted">Don’t have an account? <a href="auth-signup.html" className="f-w-400">Signup</a></p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Login;